"use client";

import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";
import Link from "next/link";
import { ProcessCard } from "@/components/screen/global-components/process";

type HowServiceWorkItem = {
  id: number;
  image?: string;
  title: string;
  description: string;
};

type DocumentsHowServiceWorksProps = {
  content?: {
    howServiceWorkTtile?: string;
    howServiceWorkDescription?: string;
    serviceButtonText?: string;
    howServiceWorkGrid?: {
      fields?: {
        icon?: {
          fields?: {
            file?: { url?: string };
          };
        };
        serviceName?: string;
        serviceDescriptions?: string;
      };
    }[];
  };
};

export default function DocumentProcessBlock() {
  // we wait data from back
  const title = "How our translation services work";
  const description =
    "Our proprietary process ensures the highest accuracy at the quickest pace. Using a three-human workflow with built-in quality assurance validation, we achieve fast and consistent precision that takes into account cultural and linguistic context across even the most complex, high-volume projects.";
  const serviceButtonText = "Explore our quality guarantee";

  const items: HowServiceWorkItem[] = [
    {
      id: 1,
      title: "Order online",
      description:
        "Use our self-service order form to choose your language pair, upload your files, and pay to initiate a project for delivery within 24 hours.",
    },
    {
      id: 2,
      title: "Dual human translate and proof",
      description:
        "Two native-speaking linguists experienced in your industry and use case will translate and edit your project while built-in quality assurance validates for accuracy. Your project manager will review for quality and validate adherence to your requirements.",
    },
    {
      id: 3,
      title: "Deliver and review",
      description:
        "We deliver your digital app translation in the layout or format specified for your approval, ensuring satisfaction with unlimited free revisions.",
    },
  ];

  return (
    <section className="section">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col justify-center gap-4 lg:gap-[29]">
          <Typography variant="heading4" className="md:text-center">
            <h2>{title}</h2>
          </Typography>
          <div className="flex md:justify-center text-gray-600 max-w-[780px] mx-auto">
            <Typography
              variant="subHeadingSm"
              className="md:text-center"
              asChild
            >
              <p>{description}</p>
            </Typography>
          </div>
        </div>

        <div className="mt-6 md:mt-12 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 justify-items-center">
          {items.map(({ id, title, description }) => {
            return (
              <ProcessCard
                key={id}
                index={id}
                title={title}
                description={description}
              />
            );
          })}
        </div>
        <div className="mt-6 lg:mt-12 text-center flex items-center justify-center">
          <Button
            asChild
            variant="primary-outline"
            className="flex-auto min-w-0 sm:flex-initial py-3 px-6 h-[48px] w-full sm:w-auto"
          >
            <Link href="/quality-guarantee" className="!text-base">
              {serviceButtonText}
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
